module.exports = __webpack_public_path__ + "static/media/transactionSuccessImg.4a7d0023.svg";